import type { LcvModelData } from '@/app/lcv/types/model-data';

export const V_CROSS_DATA: LcvModelData = {
  price: 937000,
  label: 'วี-ครอส 4x4',
  href: '/isuzu-v-cross',
  image: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltc85301a194024d99/673469ba3bea8fbb3a123798/v-cross.png',
    alt: 'ISUZU V-Cross 4x4',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb3c0cc339be4b01a/v-cross-brochure-2025.pdf',
  //NOTE: permanent link
};

export const X_SERIES_DATA: LcvModelData = {
  price: 763000,
  label: 'เอ็กซ์-ซีรี่ส์',
  href: '/isuzu-x-series',
  image: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltadbc7b00934f5ce6/65ac707ea933e51c1902763a/x-series.png',
    alt: 'x-series',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt0ae8a893222ff3a9/x-series-brochure-2024.pdf',
  //NOTE: permanent link
};

export const PICKUP_4DOOR_DATA: LcvModelData = {
  price: 749000,
  label: 'ปิกอัพ 4 ประตู',
  href: '/isuzu-pick-up-4-door',
  image: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt5b3dcd6f5876f074/673469ba4f4fa3c4e1b7b45c/4-door.png',
    alt: 'pickup 4-door',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt3b41354a46ee0207/4-doors-brochure-2025.pdf',
  //NOTE: permanent link
};

export const PICKUP_2DOOR_DATA: LcvModelData = {
  price: 668000,
  label: 'ปิกอัพ 2 ประตู',
  href: '/isuzu-pick-up-2-door',
  image: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4d77099b3da9d608/673469baa6bfe72a8e9c1818/2-door.png',
    alt: 'pickup 2-door',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt6433a174955313eb/2-doors-brochure-2025.pdf',
  //NOTE: permanent link
};

export const SPARK_DATA: LcvModelData = {
  price: 595000,
  label: 'สปาร์ค',
  href: '/isuzu-spark',
  image: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltea6d380144222014/673469ba09c2c07eef61f0b8/spark.png',
    alt: 'spark',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt390ae94120874d15/spark-brochure-2025.pdf',
  //NOTE: permanent link
};

export const MUX_ULTIMATE_DATA: LcvModelData = {
  price: 1194000,
  label: 'มิว-เอ็กซ์',
  href: '/isuzu-mu-x?model=ultimate',
  image: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt6cd60581a482ffa2/66694098371bca4188b8cf48/ultimate.png',
    alt: 'MU-X Ultimate',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltbafd73a150db898b/mu-x-brochure-2025.pdf',
  //NOTE: permanent link
};

export const MUX_RS_DATA: LcvModelData = {
  price: 1624000,
  label: 'มิว-เอ็กซ์ อาร์เอส',
  href: '/isuzu-mu-x',
  image: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb3c905d047206833/66694073b00d39b961dfe211/rs.png',
    alt: 'MU-X RS',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltbafd73a150db898b/mu-x-brochure-2025.pdf',
  specialBadge: true,
};
